import React from 'react';
import {WidgetsPane} from '..';
import 'simplebar/dist/simplebar.min.css';
import '../../simplebar.css'
import {CouponsPanel} from "../coupons/CouponsPanel";


export const RightPanel: React.FC<{ types: string[] }> = ({types}) => {
    return (
        <div className="h-full overflow-y-auto overflow-x-hidden flex flex-col">
            {types.map((type, i) => {
                switch (type) {
                    case "widget":
                        return <WidgetsPane key={i}/>
                    case "coupon":
                        return <CouponsPanel key={i}/>
                    default:
                        return <></>
                }
            })}
        </div>
    );
};
